import React from 'react';
import styles from './LevelCard.module.scss';
import { LevelAnalytics } from '../../../services/ChallengeAnalyticsService';

interface LevelCardProps {
  levelAnalytics: LevelAnalytics;
}

export const LevelCard: React.FC<LevelCardProps> = ({ levelAnalytics }) => {
  const { levelName, approved, inProcess } = levelAnalytics;

  return (
    <div className={styles.levelCard}>
      <h3 className={styles.levelTitle}>{levelName}</h3>
      
      <div className={styles.statsGrid}>
        <div className={styles.statItem}>
          <div className={styles.statNumber} style={{ color: 'var(--success-light)' }}>
            {approved}
          </div>
          <div className={styles.statLabel}>Completados</div>
        </div>
        
        <div className={styles.statItem}>
          <div className={styles.statNumber} style={{ color: 'var(--warning-light)' }}>
            {inProcess}
          </div>
          <div className={styles.statLabel}>En Proceso</div>
        </div>
      </div>
    </div>
  );
}; 